import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { IMG, byBrand } from "../mock/mock";

const DATA = {
  trash: {
    kicker: "A second house",
    title: "About the Trash",
    image: IMG.skunkTee,
    lead: "Sabotage — Ozark Mountain Trash.",
    body: [
      "Sabotage is the backwoods cousin of the infinity mark. Born in the Ozark hills where the roads turn to gravel and the WiFi gives up, it's streetwear with dirt under its nails.",
      "The mascot is a no-good trash skunk — ornery, feral, and proud of it. Distressed prints, camo, rust, and roadkill humor. It's not for everybody, and that's the point.",
      "Proudly trashy. Slower than smoke. Grandma had balls. If you get it, you get it.",
    ],
    brandId: "sabotage",
    cta: { to: "/shop?brand=sabotage", label: "Enter the trash pile" },
  },
  boothill: {
    kicker: "A third house",
    title: "The Boothill Story",
    image: IMG.boothillHome,
    lead: "Boothill Bottoms — Survive · Adapt · Thrive.",
    body: [
      "Boothill Bottoms is Missouri boothill life in the Ozarks — a heart grown from the mountains for the ones who climbed back up. Rooted deep, weathered, and still standing.",
      "The crest is a promise: survive the winter, adapt to the ridge, thrive on the other side. Earth tones, roots, ridgelines, and river bottoms.",
      "For the ones who never quit the climb. Stand on it.",
    ],
    brandId: "boothill-bottoms",
    cta: { to: "/shop?brand=boothill-bottoms", label: "Shop Boothill" },
  },
};

export default function Story({ kind }) {
  const d = DATA[kind] || DATA.trash;
  const products = byBrand(d.brandId, 4);

  return (
    <main className="pt-16 md:pt-[72px]">
      <section className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-16 grid md:grid-cols-2 gap-10 items-center">
        <div className="relative order-2 md:order-1">
          <img src={d.image} alt={d.title} className="rounded-xl border border-white/10 object-cover w-full aspect-[4/5]" />
        </div>
        <div className="order-1 md:order-2">
          <span className="inline-block text-[11px] font-bold uppercase tracking-[0.24em] text-neon mb-3">
            {d.kicker}
          </span>
          <h1 className="font-display text-5xl md:text-7xl text-white leading-none">{d.title}</h1>
          <p className="mt-4 text-sm uppercase tracking-[0.18em] text-neon">{d.lead}</p>
          <div className="mt-6 space-y-4">
            {d.body.map((para, i) => (
              <p key={para.slice(0, 40)} className="text-white/65 leading-relaxed">{para}</p>
            ))}
          </div>
          <Link
            to={d.cta.to}
            className="inline-block mt-8 bg-neon text-black font-bold uppercase tracking-[0.14em] text-sm px-8 py-4 rounded-full hover:brightness-95 transition"
          >
            {d.cta.label}
          </Link>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-4 md:px-8 pb-20">
        <h2 className="font-display text-3xl md:text-5xl text-white mb-8">From the house</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {products.map((p) => (
            <ProductCard key={p.slug} product={p} />
          ))}
        </div>
      </section>
    </main>
  );
}
